import {Injectable} from "@angular/core";
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {LoadingService} from "./loading.service";

interface RequestOptions {
  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  context?: HttpContext;
  observe?: 'body';
  params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  shouldShowLoading?: boolean;
}


/*** Generic service that interfaces with the httpClient*/
@Injectable({providedIn: "root"})
export class HttpService {

  private loadingRequests = 0

  constructor(
    private http: HttpClient,
    private loadingService: LoadingService
  ) {
  }

  get(url: string, options?: RequestOptions): Observable<any> {
    return this.withLoading(options?.shouldShowLoading, this.http.get<any>(url, options))
  }

  post(url: string, body: any, options?: RequestOptions): Observable<any> {
    return this.withLoading(options?.shouldShowLoading, this.http.post<any>(url, body, options))
  }

  put(url: string, body?: any, options?: RequestOptions): Observable<any> {
    return this.withLoading(options?.shouldShowLoading, this.http.put<any>(url, body, options))
  }

  patch(url: string, body?: any, options?: RequestOptions): Observable<any> {
    return this.withLoading(options?.shouldShowLoading, this.http.patch<any>(url, body, options))
  }

  delete(url: string, options?: RequestOptions): Observable<any> {
    return this.withLoading(options?.shouldShowLoading, this.http.delete<any>(url, options))
  }

  private withLoading(shouldDisplay: boolean | undefined, request: Observable<any>): Observable<any> {
    return new Observable(subscriber => {
      if (shouldDisplay) {
        this.loadingRequests++
        this.loadingService.setLoading(true)
      }

      const subscription = request.subscribe({
        next: value => subscriber.next(value),
        error: error => subscriber.error(error),
        complete: () => subscriber.complete()
      })

      return () => {
        if (shouldDisplay) {
          this.loadingRequests = Math.max(0, this.loadingRequests - 1)
          this.loadingService.setLoading(this.loadingRequests > 0)
        }
        subscription.unsubscribe()
      }
    })
  }

}
